// extracted by mini-css-extract-plugin
export var leftAlign = "_2c-2";
export var popper = "_2c-0";
export var subtitle = "_2c-1";